<div class="main-page-section default_font pt-3 pt-md-4 px-3 px-md-4 px-lg-5 d-flex flex-column">
    <div class="flex-fill">
        <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
            <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev"><a routerLink="/list-customer-service-user">List Customer Service
                    User</a></span>
            <span class="separator">&nbsp; &nbsp;</span>
            <img src="../../assets/images/seperator.png">
            <span class="separator">&nbsp; &nbsp;</span>
            <span class="prev-page pr-1 prev">Customer Service User
                Details</span>
        </div>

        <div class="px-3 px-md-4 px-lg-5 py-3 py-md-4 bg-lighter mx-n3 mx-md-n4 mx-lg-n5">
            <div class="row">
                <div class="col-12 col-md-6 col-lg-8">
                    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
                        <h2 class="font-weight-bold mb-3 mb-md-4">Customer Service User Details</h2>
                    </div>
                    <div class="row row-gap-4 mb-4 mb-md-5">
                        <div class="col-12 col-md-6 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Name</small>
                            <span class="font-weight-medium text-gray-dark">{{memberDetails?.data.memberName}}</span>
                        </div>
                        <div class="col-12 col-md-6 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">UserName</small>
                            <span class="font-weight-medium text-gray-dark">{{memberDetails?.data.userName}}</span>
                        </div>
                        <div class="col-12 col-md-6 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Email ID</small>
                            <span class="font-weight-medium text-gray-dark">{{memberDetails?.data.memberEmail}}</span>
                        </div>
                        <div class="col-12 col-md-6 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Phone Number</small>
                            <span class="font-weight-medium text-gray-dark">+91{{memberDetails?.data.memberPhone}}</span>
                        </div>
                        <div class="col-12 col-md-6 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Assigned Customer Service Group</small>
                            <ng-container *ngFor="let userallgroup of memberDetails?.data.serviceGroups; let last = last">{{userallgroup.groupName}}{{ !last ? ', ' : '' }}</ng-container>
                        </div>
                        <div class="col-12 col-md-6 d-flex flex-column row-gap-2">
                            <small class="font-weight-light text-gray-medium">Assigned IT Park</small>
                            <ng-container *ngFor="let userallpark of memberDetails?.data.parks; let last = last">{{userallpark.parkName}}{{ !last ? ', ' : '' }}</ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <div class="details_footer shadow-lg py-3 py-md-4 d-flex align-items-center justify-content-end column-gap-3 mx-n3 mx-md-n4 mx-lg-n5 px-3 px-md-4 px-lg-5 mt-4 mt-md-5">
        <button class="btn btn-clear text-danger" (click)="openModal(memberDetails.data?.memberName, memberDetails.data?.userName, memberDetails.data?.memberId, groupId, fromDetailsPage)">Remove</button>
        <button class="btn btn-clear text-primary" (click)="goToEditPage(memberDetails.data?.memberId)">Edit Details</button>
        <button class="btn btn-primary" (click)="openModalMoveGroup(checkedOnlyUsersList)">Change Group</button>
    </div>
</div>